<template>
    <div class="ImgList">
              <ul>
                <li v-for="(item,index) in dataList" :key='item.ID' class=" fadeInUp" :data-wow-delay="index/5+'s'">
                    <router-link  :to="item.Url" :href="item.Url"  @click.native="OpenLink(item.Url)"  >
                        <div class="imgBox"> <img :src="item.Cover" /></div>
                        <div class="textBox">
                          <p class="title txt-cut1">{{item.Title}}</p>
                          <p class="text txt-cut2">{{item.Describe}}</p>
                          <!-- <div class="time"><span>{{item.ShowTime}} </span> </div> -->
                        </div>
                    </router-link>
                </li>
             </ul>
             <div v-if="moreLink" class="more wow zoomIn" data-wow-delay="0.3s"><router-link :to="moreLink" ><em>查看更多</em></router-link></div>
    </div>
</template>
<script>
export default {
  name: 'ImgList',
  props: {
     dataList: { // 图片列表
      type: Array,
      default: () => []
     },
     moreLink: {
       type: String,
       default: ''
     },
    styles: { 
      type: Object,
      default: () => {
        return {
          width: 1920,
          height: 500
        }
      }
    }
  },
   data () {
     return {
        showItem: this.dataList? this.dataList[0]:null
     }
   },
   created(){
    //  console.log(this.dataList)
   },
  methods:{
        setTimeformat(_data,_format='yyyy-mm-dd'){
            // console.log(_data)
             return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
        }
   }
}
</script>
<style lang="less" scoped >
// $themeColor
  .ImgList{
      ul{
        li{
            position: relative;
            font-size:0;
            display: block;
            padding: 0.06rem;
            background: #fff;
            box-shadow: 0px 0px 0.06rem rgba(0, 0, 0, 0.16);
            margin-bottom: 0.2rem;
            .imgBox{
                display: inline-block;
                width: 1.7rem;
                height: 1.7rem;
                vertical-align: top;
                img{
                  object-fit: contain;
                }
            }
            .textBox{
                box-sizing: border-box;
                display: inline-block;
                width: calc(100% - 1.8rem);
                padding-left: 0.2rem;
                padding-top:0.1rem;
                height: 1.3rem;
                vertical-align: top;
            .title{
              padding-top: 0.02rem;
                font-size: 0.3rem;
                color: #333;
                line-height: 1.2;
                text-align: justify;
                padding-bottom: 0.3rem;
                position: relative;
                &::after{
                  content: "";
                  display: block;
                  position: absolute;
                  left: 0;
                  bottom: 0.15rem;
                  width: 0.5rem;
                  height: 0.02rem;
                  background: #0376be;

                }
            }
            .text{
                 font-size: 0.26rem;
                 color: #666;
                 line-height: 1.5;
            }
        
          }
        }
      }

  }

</style>


// WEBPACK FOOTER //
// src/components/ImgList.vue